<template lang="html">
  <section>
    <div class="m-card__header">
      <div
        class="m-header__icon slds-icon_container"
        :class="getIconClass(iconObj)"
        v-if="iconObj.name"
      >
        <svg class="slds-icon">
          <use :xlink:href="iconPath"></use>
        </svg>
      </div>

      <div class="m-header__title" :title="title">
        {{ title }}
        <span v-if="action"> , {{ action }} </span>
      </div>

      <settings-element
        @on-settings-edit-click="onSettingsClick"
        @on-settings-delete-click="onDeleteClick"
      />
    </div>
  </section>
</template>

<script lang="js">
  import SettingsElement from "@/views/drag-drop-pages/components/SettingsElement";
  import utils from "@/utils";

  export default  {
    name: "card-layout-header",
    components: {
      SettingsElement
    },
    props: {
      icon: {
        type: Object
      },
      title: {
        type: String
      },
      action: {
        type: String
      }
    },
    watch: {
      icon: {
        handler() {
          this.parseIcon();
        },
        immediate: true
      }
    },
    mounted () {
      this.parseIcon();
    },
    data () {
      return {
        iconObj: {}
      }
    },
    computed: {
      iconPath() {
        return utils.getIconPath(this.iconObj);
      }
    },
    methods: {
      getIconClass(item) {
        return utils.getIconClass(item);
      },
      parseIcon() {
        this.iconObj = {};
        if(this.icon) {
          this.iconObj =  this.icon;
        }
      },
      onSettingsClick() {
        this.$emit("on-edit-card-layout", {});
      },
      onDeleteClick() {
        this.$emit("on-delete-card-layout", {});
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .m-header__icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
    svg {
      @include mixin-drag-drop-list-item-svg-icon;
      background-color: transparent;
      width: 1.5rem;
      height: 1.5rem;
      margin-top: 0;
      margin-right: 0;
    }
  }
  .m-card__header {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0.75rem;
    min-height: 1rem;
  }
  .m-header__title {
    font-size: 0.8rem;
    font-weight: bold;
    flex: 1;
    min-width: 100px;
    padding-right: 0.7rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
